export default {
  returnToCall: 'Return to call',
};
